/* eslint-disable @typescript-eslint/naming-convention */
import type { DateTimePickerBlock } from '@ps/web-martech-cms-types/Form';
import { StarsDatePicker } from '@ps/web-shared-components';
import {
  equalOrAfterDateComparedWith,
  equalOrBeforeDateComparedWith,
  required
} from '@ps/web-shared-validators';
import React, { useCallback } from 'react';

// TODO refactor to use composition or shared.scss
// eslint-disable-next-line no-restricted-imports
import formStyles from '../CMSForm.scss';
import { getErrorMessage } from '../utils';

import { TXTCLI_Invalid_date } from './DateTimePicker.messages.json';

const DateTimePicker: React.FC<DateTimePickerBlock['date_time_picker']> = ({
  field_name,
  label,
  hide_date_format,
  default_date,
  min_date,
  max_date,
  required_validation,
  equal_or_before_date_validation,
  equal_or_after_date_validation
}) => {
  const getValidators = useCallback(() => {
    const validators = [];

    if (required_validation.active) {
      const errorMessage = getErrorMessage(required_validation);
      validators.push(required(errorMessage));
    }

    if (equal_or_before_date_validation.comparison_field_name) {
      const { comparison_field_name } = equal_or_before_date_validation;
      const errorMessage = getErrorMessage(equal_or_before_date_validation, TXTCLI_Invalid_date);
      validators.push(equalOrBeforeDateComparedWith(comparison_field_name, errorMessage));
    }

    if (equal_or_after_date_validation.comparison_field_name) {
      const { comparison_field_name } = equal_or_after_date_validation;
      const errorMessage = getErrorMessage(equal_or_after_date_validation, TXTCLI_Invalid_date);
      validators.push(equalOrAfterDateComparedWith(comparison_field_name, errorMessage));
    }

    return validators;
  }, [required_validation, equal_or_before_date_validation, equal_or_after_date_validation]);

  const labelComponent = (
    <>
      {label}
      {required_validation.active && <span className={formStyles.requiredIndicator}>*</span>}
    </>
  );

  return (
    <StarsDatePicker
      key={field_name}
      id={field_name}
      label={labelComponent}
      defaultDate={default_date}
      minDate={min_date}
      maxDate={max_date}
      validators={getValidators()}
      hideDateFormat={hide_date_format}
    />
  );
};

export default DateTimePicker;
